// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__C3as_","form_group":"Form_form_group__IR2Z3","form_control":"Form_form_control__8X8s8"};